import React, { useState, useEffect } from 'react'

import { Dropdown } from 'semantic-ui-react'


interface Option {
  text: string,
  value: number
}

const getOptions = (playerCount: number): Option[] => {
  let options: Option[] = [];
  for (let i = 4; i < 13; i++) {
    const k = (playerCount * i) / 4;
    if (Number.isInteger(k)) {
      options.push(
        { text: i + '', value: i }
      )
    }
  }
  return options;
}

const GroupStageMatchesDropdown = (props: {
  playerCount: number,
  groupMatches: number,
  totalGroupStageMatches: number,
  updateGroupMatches: (val: number) => void
}) => {
  const { playerCount } = props;
  const [options, setOptions] = useState(getOptions(playerCount))

  useEffect(() => {
    setOptions(getOptions(playerCount))
  }, [playerCount])

  useEffect(() => {
    if (options.length > 0) {
      props.updateGroupMatches(options[0].value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options])

  const onChange = (e: any, val: any) => {
    props.updateGroupMatches(val);
  }

  return (
    <p>
      Group stage matches pr player:{' '}
      <Dropdown
        className='button melee basic icon'
        floating
        onChange={(e: any, { value }) => onChange(e, value)}
        options={options}
        value={props.groupMatches}
      />
      . Total group stage matches: <b>{props.totalGroupStageMatches}</b>
    </p>
  )
}

export default GroupStageMatchesDropdown;
